module.exports = __webpack_public_path__ + "static/media/situation-icon.f5622bdc.svg";